<header class="header p-3">
    <nav class="container">
        <div class="d-flex flex-wrap align-items-center justify-content-center">
            <!-- LOGO -->
            <a href="/"
                class="text-decoration-none">
                <picture>
                    <source media="(prefers-color-scheme: dark)"
                        srcset="/assets/images/CallRevu_Logo_Wordmark_Standard_White_RGB.svg">
                    <img src="/assets/images/CallRevu_Logo_Wordmark_Standard_Black_RGB.svg"
                        alt="CallRevu">
                </picture>
            </a>
            <div class="header__text">Agent Voice ID Setup</div>
        </div>
    </nav>
</header>